<h2 mat-dialog-title>
  <mat-icon class="title-icon">local_offer</mat-icon>
  Stats: {{ data.code }}
</h2>

<mat-dialog-content>

  <mat-list>
    <mat-list-item>
      <mat-icon matListItemIcon>toggle_on</mat-icon>
      <div matListItemTitle>Status</div>
      <div matListItemLine>{{ data.isActive ? 'Active' : 'Inactive' }}</div>
    </mat-list-item>

    <mat-list-item>
      <mat-icon matListItemIcon>discount</mat-icon>
      <div matListItemTitle>Discount</div>
      <div matListItemLine>
        {{ data.discountType === 'percentage' ? data.discountValue + '%' : 'NOK ' + data.discountValue }}
      </div>
    </mat-list-item>

    <mat-list-item *ngIf="isStoredValueCoupon">
      <mat-icon matListItemIcon>account_balance_wallet</mat-icon>
      <div matListItemTitle>Remaining Balance</div>
      <div matListItemLine>{{ remainingBalanceDisplay }}</div>
    </mat-list-item>

    <mat-list-item *ngIf="isStoredValueCoupon">
      <mat-icon matListItemIcon>payments</mat-icon>
      <div matListItemTitle>Redeemed Amount</div>
      <div matListItemLine>{{ spentAmountDisplay }}</div>
    </mat-list-item>

    <mat-list-item>
      <mat-icon matListItemIcon>event</mat-icon>
      <div matListItemTitle>Valid Period</div>
      <div matListItemLine>{{ validFromDisplay }} — {{ validUntilDisplay }}</div>
    </mat-list-item>

    <mat-list-item>
      <mat-icon matListItemIcon>schedule</mat-icon>
      <div matListItemTitle>Created</div>
      <div matListItemLine>{{ createdAtDisplay }}</div>
    </mat-list-item>

    <mat-list-item>
      <mat-icon matListItemIcon>person</mat-icon>
      <div matListItemTitle>Created By</div>
      <div matListItemLine>{{ createdByDisplay }}</div>
    </mat-list-item>
  </mat-list>

  <div class="usage-section">
    <div class="usage-header">
      <span>Redemptions</span>
      <span>{{ data.usedCount }}</span>
    </div>
    <div class="usage-note" *ngIf="isStoredValueCoupon">
      Fixed-value gavekort keeps any unused amount for later purchases.
    </div>
  </div>

  <div class="used-by-section" *ngIf="recentUsedBy.length > 0">
    <h4>Recent Users (last 10)</h4>
    <mat-list dense>
      <mat-list-item *ngFor="let userId of recentUsedBy">
        <mat-icon matListItemIcon>person</mat-icon>
        <div matListItemTitle>{{ userId }}</div>
      </mat-list-item>
    </mat-list>
  </div>

  <div class="no-uses" *ngIf="data.usedCount === 0">
    <mat-icon>info</mat-icon>
    This coupon has not been used yet.
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
